export default __webpack_public_path__ + "static/media/ic_flag_fr.35afd52c.svg";